export default __webpack_public_path__ + "static/media/6OctoberLogo.d558fba2.jpg";